var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSilverChair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 142,
    viewBox: "0 0 143 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.896 70.9999C140.896 109.435 109.751 140.58 71.3163 140.58C32.8817 140.58 1.73633 109.435 1.73633 70.9999C1.73633 32.5653 32.8817 1.41992 71.3163 1.41992C109.751 1.41992 140.896 32.5653 140.896 70.9999Z",
    fill: "url(#paint0_linear_1545_9259)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1545_9259)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.3153,
    cy: 70.9999,
    r: 61.3872,
    stroke: "#98A2B3",
    strokeWidth: 4.07895
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1545_9259)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.413 46.1794C103.439 46.3125 103.462 46.4299 103.495 46.5139C103.561 46.679 103.029 51.6148 102.392 57.5294C101.481 65.9774 100.355 76.422 100.45 77.8127C100.45 79.8165 99.2474 102.339 98.8467 109.472C98.7665 110.674 97.7646 111.636 96.5624 111.636H96.0414C94.759 111.636 93.7571 110.594 93.7571 109.352C93.7571 103.661 93.677 88.9938 92.8354 83.9843C92.114 79.8566 90.1503 78.8547 87.6657 78.7746L86.4233 100.014C86.3432 101.217 85.3413 102.179 84.139 102.179C82.9368 102.179 81.9349 101.257 81.8547 100.055L80.4922 79.2555C78.6373 79.378 77.5542 79.5234 76.5488 79.6583C75.2517 79.8325 74.084 79.9892 71.5554 80.057H71.4752C68.8073 79.9855 67.5553 79.8291 66.0948 79.6466C65.0983 79.5221 64.0047 79.3855 62.298 79.2555L60.9354 100.055C60.8553 101.257 59.8534 102.179 58.6511 102.179C57.4489 102.179 56.447 101.217 56.3668 100.014L55.1245 78.7746C52.6398 78.8948 50.6761 79.8566 49.9548 83.9843C49.0731 88.9938 49.0331 103.661 49.0331 109.352C49.0331 110.634 47.9911 111.636 46.7488 111.636H46.2278C45.0255 111.636 44.0236 110.674 43.9435 109.472C43.8371 107.367 43.6539 103.922 43.4485 100.06C42.9578 90.8334 42.3405 79.2252 42.3405 77.8127C42.3405 76.5596 41.3949 67.9554 40.5299 60.0847C39.7628 53.1051 39.0591 46.7023 39.1345 46.5139C39.168 46.4299 39.1911 46.3125 39.2172 46.1794C39.3157 45.6771 39.4582 44.951 40.3768 44.951H43.9836C43.9836 44.951 45.3061 44.0293 47.7907 37.0562C50.1834 30.3026 59.1167 30.3499 61.5285 30.3626C61.6212 30.3631 61.7043 30.3636 61.777 30.3636H81.1334C81.2064 30.3636 81.2894 30.3631 81.3818 30.3626C83.7759 30.3499 92.4468 30.3036 94.8391 37.0562C97.3238 44.0293 98.6463 44.951 98.6463 44.951H102.253C103.172 44.951 103.314 45.6771 103.413 46.1794ZM58.3706 67.8741L60.0938 40.4225C60.2541 38.3386 59.2122 36.3749 56.4069 37.4569C54.6252 38.1442 53.6841 40.3187 52.6904 42.6149C52.1195 43.934 51.5313 45.2933 50.7563 46.4338C49.1533 48.9585 48.9128 49.0387 47.7106 49.239C44.4244 49.3192 44.9053 51.884 44.9053 51.884C46.5885 69.6374 53.1608 68.7958 53.1608 68.7958H56.6474C58.4107 68.8359 58.3706 67.8741 58.3706 67.8741ZM68.1891 57.9354C68.5097 57.9354 68.7501 57.6949 68.7501 57.3743V42.1457C68.7501 41.8251 68.5097 41.5847 68.1891 41.5847C67.8685 41.5847 67.628 41.8251 67.628 42.1457V57.3743C67.628 57.6949 67.8685 57.9354 68.1891 57.9354ZM74.7614 57.9354C75.082 57.9354 75.3225 57.6949 75.3225 57.3743V42.1457C75.3225 41.8251 75.082 41.5847 74.7614 41.5847C74.4408 41.5847 74.2004 41.8251 74.2004 42.1457V57.3743C74.2004 57.6949 74.4408 57.9354 74.7614 57.9354ZM89.4691 68.7958C89.4691 68.7958 96.0815 69.5973 97.7246 51.884C97.7246 51.884 98.2055 49.3192 94.9193 49.239C93.717 49.0387 93.4766 48.9585 91.8736 46.4338C90.9937 45.1388 90.5539 43.5619 90.1412 42.0819C89.5577 39.9894 89.0283 38.0907 87.3851 37.4569C84.5799 36.3749 83.4978 38.3786 83.6581 40.4225L85.3814 67.8741C85.3814 67.8741 85.3413 68.8359 87.1046 68.7958H89.4691ZM71.4354 68.8359C79.6909 68.8359 80.4123 68.6756 80.4123 68.4752C80.4123 68.2748 79.731 68.1145 71.4354 68.1145C63.1799 68.1145 62.178 68.2748 62.178 68.4752C62.178 68.6756 63.1799 68.8359 71.4354 68.8359Z",
    fill: "#98A2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1545_9259",
    x: 7.88867,
    y: 7.57324,
    width: 126.854,
    height: 128.485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9259"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1545_9259",
    x: 39.1289,
    y: 30.3613,
    width: 64.3711,
    height: 82.9065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9259"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1545_9259",
    x1: 23.0363,
    y1: 16.5666,
    x2: 124.566,
    y2: 115.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSilverChair);
export default __webpack_public_path__ + "static/media/IconSilverChair.e7fbe4defa7fb2ea0efd906d3a4f1182.svg";
export { ForwardRef as ReactComponent };